import { addCustomSpans } from '@atlaskit/react-ufo/interaction-metrics';

import { type UfoDurationMetrics } from './durationMetrics';

const mediaLabelStack = [{ name: 'media' }];

export const sendUfoDurationMetrics = (
	ufoDurationMetrics: UfoDurationMetrics,
	endpoint: 'image' | 'items',
): void => {
	const labelStack = [...mediaLabelStack, { name: endpoint }];
	Object.entries(ufoDurationMetrics).map(([name, { start, end, size }]) => {
		addCustomSpans(name, start, end, size, labelStack);
	});
};
